import { getUrl } from "aws-amplify/storage";
import { apiGetSensor, apiListCameraImagePastFlood, apiListCameraSensorHistories6hAgo } from "apis/SensorApi";
import Icon, { IconList } from "components/Icon";
import { TEXT_BASE_DISPLAY } from "constants/message";
import { useAuth } from "context/AuthContext";
import { useGeneralSetting } from "context/GeneralSettingContext";
import { useSensorGroups } from "context/SensorGroupsContext";
import { SensorType } from "models";
import CameraDisplayer from "pages/components/CameraDisplayer";
import CameraTrafficVolumeChart from "pages/SensorList/components/CameraTrafficVolumeChart";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import MiniMapView from "./components/MiniMap";
import ImageZoom from "./components/ImageZoom";
import { IconSensor } from "pages/SensorList/components/SensorDetailHeader";
import "./BasePage.css";
import PropTypes from 'prop-types';
import html2canvas from "html2canvas";
import { downloadExcelWithSensorData } from "./helpers";
import FanLoadingIcon from "components/FanLoadingIcon";
import moment from 'moment-timezone';

const propTypes = {
  onViewSensorDetail: PropTypes.func,
};
const defaultProps = {
  onViewSensorDetail: (sensor) => { },
};

const ZoomDataCapture = ({ size, setZoomData }) => {
  useEffect(() => {
    setZoomData((prevData) => {
      if (prevData.src) {
        if (prevData.size?.width !== size?.width || prevData.size?.height !== size?.height) {
          return { ...prevData, size: size };
        }
        return prevData;
      }
      return { ...prevData, size: size };
    });
  }, [size, setZoomData]);
  return null;
};

const CameraSensorInfo = ({ targetSensor, targetGroup, onViewSensorDetail, generalSetting }) => {
  const [listImageKey6hAgoCamera1, setListImageKey6hAgoCamera1] = useState([]);
  const [listImageKey6hAgoCamera2, setListImageKey6hAgoCamera2] = useState([]);
  const [listPastFloodImageKeyCamera1, setListPastFloodImageKeyCamera1] = useState([]);
  const [listPastFloodImageKeyCamera2, setListPastFloodImageKeyCamera2] = useState([]);
  const [showPastFloodButton, setShowPastFloodButton] = useState(false);
  const [image1Src, setImage1Src] = useState("");
  const [image2Src, setImage2Src] = useState("");
  const [typeDisplayCamera, setTypeDisplayCamera] = useState(targetSensor.data.typeDisplayCamera || "IMAGE");
  const [zoomData, setZoomData] = useState({ src: null, size: null });
  const intervalRef1 = useRef(null);
  const intervalRef2 = useRef(null);
  const { currentUser } = useAuth();
  const { keyNewestImage, swapImageCamera, keyNewestImage2, cameraFeature, typeCamera, zoomImageFeature, zoomCenterCoordinateY, zoomCenterCoordinateX, zoomImageRate, username, password, ipAddress, imageAnalysisLastFloodDetectedStatus_1, imageAnalysisLastFloodDetectedStatus_2, imageAnalysisResponse_1, imageAnalysisResponse_2 } = targetSensor.data;

  useEffect(() => {
    fetchImageData();
    const interval1 = intervalRef1.current;
    const interval2 = intervalRef2.current;
    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, [targetSensor.id]);

  const fetchImageData = async () => {
    try {
      const [dataCamera1, listPastFloodImageKeyCamera1Response] = await Promise.all([
        apiListCameraSensorHistories6hAgo(targetSensor.id),
        apiListCameraImagePastFlood(targetSensor.id)
      ]);
      const hasImagesCam1 = listPastFloodImageKeyCamera1Response.data && listPastFloodImageKeyCamera1Response.data.length > 0;
      const listKeyCamera1 = dataCamera1.data.map((item) => item.keyImage);
      const images6hAgoCamera1 = removeRandomElements(listKeyCamera1);
      setListImageKey6hAgoCamera1(images6hAgoCamera1);
      const lastImageCamera1 = listKeyCamera1[listKeyCamera1.length - 1];
      const listPastFloodKeyCamera1 = removeRandomElements(listPastFloodImageKeyCamera1Response.data.map((item) => item.key));
      setListPastFloodImageKeyCamera1([...listPastFloodKeyCamera1, lastImageCamera1]);
      let hasImagesCam2 = false;
      if (typeCamera === "DOUBLE") {
        const [dataCamera2, listPastFloodImageKeyCamera2Response] = await Promise.all([
          apiListCameraSensorHistories6hAgo(targetSensor.id, 2),
          apiListCameraImagePastFlood(targetSensor.id, 2)
        ]);
        hasImagesCam2 = listPastFloodImageKeyCamera2Response.data && listPastFloodImageKeyCamera2Response.data.length > 0;
        const listKeyCamera2 = dataCamera2.data.map((item) => item.keyImage);
        const images6hAgoCamera2 = removeRandomElements(listKeyCamera2);
        setListImageKey6hAgoCamera2(images6hAgoCamera2);
        const lastImageCamera2 = listKeyCamera2[listKeyCamera2.length - 1];
        const listPastFloodKeyCamera2Data = removeRandomElements(listPastFloodImageKeyCamera2Response.data.map((item) => item.key));
        setListPastFloodImageKeyCamera2([...listPastFloodKeyCamera2Data, lastImageCamera2]);
      }
      if (hasImagesCam1 || hasImagesCam2) {
        setShowPastFloodButton(true);
      } else {
        setShowPastFloodButton(false);
      }
    } catch (error) {
      setShowPastFloodButton(false);
    }
  };

  const getUrls = async (list = []) => {
    const urls = await Promise.all(
      list.map(async (key) => {
        try {
          const res = await getUrl({ key });
          return res.url.toString();
        } catch (error) {
          return null;
        }
      })
    );
    return urls.filter(url => url !== null);
  };

  function removeRandomElements(array = []) {
    if (array.length > 80) {
      let numberOfElementsToRemove = array.length - 80;
      let itemsToRemove = [];
      while (itemsToRemove.length < numberOfElementsToRemove) {
        const randomIndex = Math.floor(Math.random() * (array.length - 2)) + 1;
        const randomItem = array[randomIndex];
        if (!itemsToRemove.includes(randomItem)) {
          itemsToRemove.push(randomItem);
        }
      }
      return array.filter((item) => !itemsToRemove.includes(item));
    }
    return array;
  }

  const getIntervalTime = (list) => (list.length <= 40 ? 500 : (20 * 1000) / list.length);

  const startSlide = async (list, setImageSrc, intervalRef, endSlide) => {
    if (list.length <= 1) {
      endSlide();
      return;
    };
    const urlList = await getUrls(list);
    if (urlList.length === 0) {
      endSlide();
      return;
    }
    setTypeDisplayCamera("IMAGE");
    let index = 0;
    const intervalTime = getIntervalTime(urlList);
    intervalRef.current = setInterval(() => {
      setImageSrc(urlList[index]);
      index = (index + 1) % urlList.length;
      if (index === 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        endSlide();
      }
    }, intervalTime);
  };

  const handleRunSlide = (list1, list2) => {
    let slide1Completed = false;
    let slide2Completed = false;
    const endSlide = () => {
      if (slide1Completed && (slide2Completed || typeCamera !== "DOUBLE")) {
        if (targetSensor.data.typeDisplayCamera === "VIDEO") {
          setTypeDisplayCamera("VIDEO");
        }
      }
    };
    startSlide(list1, setImage1Src, intervalRef1, () => {
      slide1Completed = true;
      endSlide();
    });
    if (typeCamera === "DOUBLE") {
      startSlide(list2, setImage2Src, intervalRef2, () => {
        slide2Completed = true;
        endSlide();
      });
    }
  };

  const buttonComponent = ({ condition, label, icon, toolTipContent, toolTipStyle, wrapperStyle, ...props }) => {
    const defaultCondition = generalSetting?.cameraWindowButtonOn;
    if (!condition || !defaultCondition) return null;
    return (
      <div className="base-page-camera-btn-wrapper" style={wrapperStyle}>
        <button className="base-page-flex-row base-page-camera-btn" {...props}>
          <span>{label}</span>
          {icon && <Icon icon={icon} />}
        </button>
        {toolTipContent && (
          <div className="base-page-camera-btn-popup" style={toolTipStyle}>
            {toolTipContent}
          </div>
        )}
      </div>
    );
  };

  const subComponent = ({ size, cameraNumber }) => {
    return (
      <>
        <ZoomDataCapture size={size} setZoomData={setZoomData} />
        <div className="base-page-camera-card-btn-group">
          {buttonComponent({
            condition: true,
            label: "過去画像",
            onClick: () => {
              onViewSensorDetail(targetSensor, { cameraNumber });
            },
          })}
          {buttonComponent({
            condition: currentUser?.data?.maximizeVideo,
            label: "現在の動画",
            toolTipContent: typeCamera !== "DOUBLE" ? "長時間の動画閲覧は月額通信量を超過し通信速度が低下します" : "",
            onClick: () => {
              if (typeDisplayCamera === "VIDEO") {
                const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/mjpg/video.cgi?camera=${cameraNumber}`;
                window.open(location, "_blank");
              } else {
                const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/jpg/image.cgi?camera=${cameraNumber}`;
                window.open(location, "_blank");
              }
            },
          })}
          {buttonComponent({
            condition: currentUser?.data?.recordedVideo,
            label: "録画動画",
            onClick: () => {
              const location = `http://${ipAddress}/camera/index.html#/recordings`;
              window.open(location, "_blank");
            },
          })}
          {buttonComponent({
            condition: true,
            label: "直近6時間",
            onClick: () => {
              handleRunSlide(listImageKey6hAgoCamera1, listImageKey6hAgoCamera2)
            },
            disabled: intervalRef1.current || intervalRef2.current,
          })}
          {buttonComponent({
            condition: showPastFloodButton,
            label: "過去登録時",
            onClick: () => {
              handleRunSlide(listPastFloodImageKeyCamera1, listPastFloodImageKeyCamera2)
            },
            disabled: intervalRef1.current || intervalRef2.current,
          })}
        </div>
      </>
    );
  };

  return (
    <div className="base-page-camera-card">
      {cameraFeature && (
        <div className={`base-page-camera-card-displayer ${zoomImageFeature && zoomData.size?.width > 0 ? 'has-zoom' : ''}`}>
          {/* Camera 1 */}
          <div className="base-page-camera-card-displayer-wrapper">
            <CameraDisplayer
              targetSensor={targetSensor}
              cameraNumber={swapImageCamera ? 2 : 1}
              isDisplayVideo={typeDisplayCamera === "VIDEO"}
              isImageAnalysis={false}
              style={{ width: "100%" }}
              imageProps={{
                key: swapImageCamera ? keyNewestImage2 : keyNewestImage,
                src: swapImageCamera ? image2Src : image1Src,
              }}
              buttonStatusProps={{
                status: {
                  color: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_2 : imageAnalysisLastFloodDetectedStatus_1]?.color,
                  value: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_2 : imageAnalysisLastFloodDetectedStatus_1]?.value,
                },
                toolTipContent: swapImageCamera ? imageAnalysisResponse_2 : imageAnalysisResponse_1,
              }}
              subComponent={subComponent}
            />
            <div
              className="base-page-camera-card-displayer-above"
              onClick={() => {
                const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/jpg/image.cgi?camera=${swapImageCamera ? 2 : 1}`;
                window.open(location, "_blank");
              }}
            ></div>
          </div>
          {/* Camera 2 - Only show if DOUBLE camera type */}
          {typeCamera === "DOUBLE" && (
            <div className="base-page-camera-card-displayer-wrapper">
              <CameraDisplayer
                targetSensor={targetSensor}
                cameraNumber={swapImageCamera ? 1 : 2}
                isDisplayVideo={typeDisplayCamera === "VIDEO"}
                isImageAnalysis={false}
                style={{ width: "100%" }}
                imageProps={{
                  key: swapImageCamera ? keyNewestImage : keyNewestImage2,
                  src: swapImageCamera ? image1Src : image2Src,
                }}
                buttonStatusProps={{
                  status: {
                    color: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_1 : imageAnalysisLastFloodDetectedStatus_2]?.color,
                    value: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_1 : imageAnalysisLastFloodDetectedStatus_2]?.value,
                  },
                  toolTipContent: swapImageCamera ? imageAnalysisResponse_1 : imageAnalysisResponse_2,
                }}
                subComponent={subComponent}
              />
              <div
                className="base-page-camera-card-displayer-above"
                onClick={() => {
                  const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/jpg/image.cgi?camera=${swapImageCamera ? 1 : 2}`;
                  window.open(location, "_blank");
                }}
              ></div>
            </div>
          )}
          {typeCamera !== "DOUBLE" && zoomImageFeature && zoomData.size?.width > 0 && (
            <ImageZoom
              zoomData={zoomData}
              zoomImageFeature={zoomImageFeature}
              zoomImageRate={zoomImageRate}
              zoomCenterCoordinateX={zoomCenterCoordinateX}
              zoomCenterCoordinateY={zoomCenterCoordinateY}
              imageProps={{
                key: keyNewestImage,
                src: image1Src,
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

const BasePage = ({ onViewSensorDetail }) => {
  const { id: sensorId } = useParams();
  const [currentSensor, setCurrentSensor] = useState(null);
  const [loading, setLoading] = useState(true);
  const { generalSetting } = useGeneralSetting();
  const { sensorGroups } = useSensorGroups();
  const [targetGroup, setTargetGroup] = useState(null);
  // Map reference for capturing
  const mapRef = useRef(null);

  useEffect(() => {
    const fetchSensorData = async () => {
      if (sensorId) {
        setLoading(true);
        try {
          const res = await apiGetSensor(sensorId);
          if (res.success && res.data) {
            const sensorData = res.data;
            sensorData.latitude = sensorData.lat || 21.028511;
            sensorData.longitude = sensorData.lng || 105.804817;
            setCurrentSensor(sensorData);
            const group = sensorGroups.find((g) => g.id === sensorData.groupId);
            setTargetGroup(group);
          } else {
            setCurrentSensor(null);
          }
        } catch (error) {
          setCurrentSensor(null);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchSensorData();
  }, [sensorId, sensorGroups]);

  const onDownloadExcel = async (templateType, datasets, filename) => {
    try {
      setLoading(true);

      // Get map node and create canvas
      const mapNode = mapRef.current;
      if (!mapNode) return;
      const canvas = await html2canvas(mapNode, {
        useCORS: true,
      });

      // Load example sensor data
      const strDay = moment().format('YYYY年MM月DD日(ddd)');
      let sensorData = {
        sensorName: currentSensor.name || 'No Information',
        createAt: strDay,
        datasets,
      };

      // Get base64 image data from canvas
      const imgData = canvas.toDataURL("image/png");
      // const imgData = null; // Skip image for now due to CORS issues
      await downloadExcelWithSensorData(templateType, imgData, sensorData, filename);

    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!currentSensor) {
    return <div className="base-page-detail-header">Sensor information not found.</div>;
  }

  const isCamera = targetGroup?.type === SensorType.CAMERA;
  const sensorLocation = currentSensor && currentSensor.latitude && currentSensor.longitude ? { lat: currentSensor.latitude, lng: currentSensor.longitude } : null;

  return (
    <div className="base-page-container">
      {loading && <FanLoadingIcon size={80} />}
      <div className="base-page-detail-header-row base-page-detail-header">
        <div className="base-page-detail-header-row base-page-detail-header-title">
          <div className="base-page-detail-header-row base-page-detail-header-symbol">
            <Icon icon={IconList.iconListingDetail} />
            <label className="base-page-detail-header-text">{TEXT_BASE_DISPLAY}</label>
          </div>
          <Icon icon={IconList.iconAllowDetail} />
        </div>
        <div className="base-page-detail-header-row">
          <IconSensor
            color={targetGroup?.messages?.[currentSensor.status]?.color || '#0A3D71'}
            type={targetGroup?.type}
            sensor={currentSensor}
            position="header"
          />
          <label className="base-page-detail-header-subtitle">{currentSensor.name}</label>
        </div>
      </div>
      <div className="base-page-content-wrapper">
        {isCamera && targetGroup ? (
          <div className="base-page-camera-and-map-container">
            <div className="base-page-camera-info-container">
              <CameraSensorInfo targetSensor={currentSensor} targetGroup={targetGroup} generalSetting={generalSetting} onViewSensorDetail={onViewSensorDetail} />
            </div>
            {sensorLocation && (
              <div className="base-page-map-container">
                <MiniMapView ref={mapRef} center={sensorLocation} zoom={25} popupText={`Location of: ${currentSensor.name}`} targetGroup={targetGroup} currentSensor={currentSensor} />
                <div className="base-page-chart-wrapper">
                  <CameraTrafficVolumeChart sensor={currentSensor} noMargin defaultToHour onDownloadExcel={onDownloadExcel} />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            <p style={{ padding: "0 32px" }}>This is a different type of sensor (not a camera).</p>
          </div>
        )}
      </div>
    </div>
  );
};

BasePage.propTypes = propTypes;
BasePage.defaultProps = defaultProps;
export default BasePage;
